export function getObjectEntries(
  obj: Object
): ReturnType<typeof Object.entries> {
  try {
    return Object.entries(obj);
  } catch {
    return [];
  }
}
